import { memo, type ReactNode } from "react";
import clsx from "clsx";

interface IProps {
  children: ReactNode;
  className?: string;
}

export const Container = memo(function Container({
  children,
  className,
}: IProps) {
  return (
    <div className={clsx(`d-flex-column gap-20`, className)}>{children}</div>
  );
});
Container.displayName = "Container";
